import { render, staticRenderFns } from "./del.vue?vue&type=template&id=91d655a4"
import script from "./del.vue?vue&type=script&lang=js"
export * from "./del.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91d655a4')) {
      api.createRecord('91d655a4', component.options)
    } else {
      api.reload('91d655a4', component.options)
    }
    module.hot.accept("./del.vue?vue&type=template&id=91d655a4", function () {
      api.rerender('91d655a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/del.vue"
export default component.exports